import React, { useMemo } from 'react';
import { LexicalComposer } from '@lexical/react/LexicalComposer';
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin';
import { ContentEditable } from '@lexical/react/LexicalContentEditable';
import { LexicalErrorBoundary } from '@lexical/react/LexicalErrorBoundary';
import { OnChangePlugin } from '@lexical/react/LexicalOnChangePlugin';
import type { EditorState } from 'lexical';
import { EdgeLexNodeRegistry, EdgeLexLegalTheme } from '../../../dms/config/EdgeLexNodeRegistry';

export interface MinimalLexicalPreviewProps {
  initialJson: unknown; // Lexical JSON object
  readOnly?: boolean;
  onChange?: (jsonString: string) => void;
}

export const MinimalLexicalPreview: React.FC<MinimalLexicalPreviewProps> = ({ initialJson, readOnly = true, onChange }) => {
  const editorStateString = useMemo(() => JSON.stringify(initialJson || {}), [initialJson]);

  const initialConfig = useMemo(() => ({
    namespace: 'EdgeDocsPreview',
    nodes: EdgeLexNodeRegistry,
    theme: EdgeLexLegalTheme,
    onError: (error: Error) => console.error('Lexical preview error:', error),
    editable: !readOnly,
    editorState: editorStateString,
  }), [editorStateString, readOnly]);

  return (
    <LexicalComposer initialConfig={initialConfig}>
      <div className="h-full flex flex-col">
        <RichTextPlugin
          contentEditable={
            <ContentEditable className="flex-1 p-6 focus:outline-none bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100" />
          }
          placeholder={<div className="absolute top-6 left-6 text-gray-400">Start typing…</div>}
          ErrorBoundary={LexicalErrorBoundary}
        />
        {onChange && (
          <OnChangePlugin
            onChange={(editorState: EditorState) => {
              const json = editorState.toJSON();
              onChange(JSON.stringify(json));
            }}
          />
        )}
      </div>
    </LexicalComposer>
  );
};

export default MinimalLexicalPreview;


